var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIconPdfDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    xmlSpace: "preserve",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+0lEQVR4nO2YXW7CMBCE94lLAOclPVDpAbgKUGln9gypIuhDxU/sRnZimE+apzx4P3kcJTYTDQNEXzMmkRGKL3BFIqlIJBNIJBGJZAKJJCKRTCARM+v7fuXODyDOtb+pcuMeJ3d2w8w3IsODuQdEthC7e9u5+J3Abb4f9rK1mERQM/wkuSa5AbhvVoTk5ne+iNhKBLOH+0HgIsGvhkViNBLBwmISwbJiEkG9/xFIBG8sAvAwves8SORlq+Uep9ZE3OM46fJherX+Vun/Itw9ug7qUnZmbhF/dh2UQu1qWbMLzClS8vVrEnnnapUAEklk+lnIi5XiZUSElecHmPgTeBsrv7AAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconPdfDarkMode);
export default __webpack_public_path__ + "static/media/print_icon_pdf_dark_mode.b1768ad6866b07d73ab0fb96ee2614e6.svg";
export { ForwardRef as ReactComponent };